export default "__VITE_ASSET__Be2Z58YG__"